import { useSelector } from "react-redux"
import { RootState } from "Shared/store/rootState.interface"

export const usePaymentSettings = () => useSelector(({ payment: { settings } }: RootState) => settings)

export const usePaymentProducts = () => useSelector(({ payment: { products } }: RootState) => products)

